export default __webpack_public_path__ + "static/surrounded-a57e01d736125e55ceea94012dabd859.svg";